import React, {lazy} from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';
const Account = lazy(() => import('../../../modules/account/MyProfile'));

export const accountPagesConfigs = [
  {
    permittedRole: [RoutePermittedRole.User, RoutePermittedRole.Admin],
    path: '/account',
    element: <Account />,
  },
];
